module.exports = __webpack_public_path__ + "img/no-img-good.8b9f970.png";